var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { FiAlertCircle, FiSearch } from "react-icons/fi";

var Input = function Input(_ref) {
  var className = _ref.className,
      placeholder = _ref.placeholder,
      label = _ref.label,
      error = _ref.error,
      search = _ref.search,
      fluid = _ref.fluid,
      value = _ref.value,
      icon = _ref.icon,
      inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["className", "placeholder", "label", "error", "search", "fluid", "value", "icon", "inputRef"]);

  var ref = useRef();

  var _useState = useState((value || value === 0) && value.toString().length > 0),
      inputHasValue = _useState[0],
      setInputHasValue = _useState[1];

  useEffect(function () {
    var listener = function listener(e) {
      if (e.currentTarget.value) {
        setInputHasValue(e.currentTarget.value.length > 0);
      } else {
        setInputHasValue(false);
      }
    };

    if (ref.current) {
      ref.current.addEventListener("blur", listener);
    }
    return function () {
      if (ref.current) {
        ref.current.removeEventListener("blur", listener);
      }
    };
  }, [ref.current]);

  return React.createElement(
    "div",
    null,
    React.createElement(
      InputWrapper,
      { className: className, fluid: fluid },
      React.createElement(InputField, _extends({
        placeholder: placeholder,
        label: label,
        error: error,
        value: value,
        icon: icon,
        fluid: fluid,
        search: search,
        ref: inputRef || ref
      }, props)),
      React.createElement(
        Label,
        { error: error, inputHasValue: inputHasValue },
        label
      ),
      search && React.createElement(IconSearch, { label: label }),
      icon && React.createElement(
        Icon,
        { label: label },
        icon
      )
    ),
    error && React.createElement(
      ErrorMessage,
      null,
      React.createElement(
        "div",
        null,
        React.createElement(StyledFiAlertCircle, null)
      ),
      React.createElement(
        ErrorText,
        null,
        error
      )
    )
  );
};

var InputWrapper = styled.div.withConfig({
  displayName: "Input__InputWrapper",
  componentId: "q0n91z-0"
})(["display:inline-block;width:", ";position:relative;cursor:text;"], function (_ref2) {
  var fluid = _ref2.fluid;
  return fluid ? "100%" : "auto";
});

var InputField = styled.input.withConfig({
  displayName: "Input__InputField",
  componentId: "q0n91z-1"
})(["box-sizing:border-box;width:", ";padding:", ";padding-right:", ";padding-left:", ";border-radius:8px;font-family:", ";font-size:18px;line-height:24px;border:1px solid ", ";background-color:white;transition:border 0.2s ease-out;-webkit-appearance:none;&::placeholder{color:#7e7e7e;opacity:", ";}&:focus{outline:none;border:1px solid ", ";&::placeholder{opacity:1;}}"], function (_ref3) {
  var fluid = _ref3.fluid;
  return fluid && "100%";
}, function (_ref4) {
  var label = _ref4.label;
  return label ? "32px 16px 14px 16px" : "23px 16px";
}, function (_ref5) {
  var icon = _ref5.icon;
  return icon && "3em";
}, function (_ref6) {
  var search = _ref6.search;
  return search && "3em";
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
}, function (_ref8) {
  var theme = _ref8.theme,
      error = _ref8.error;
  return error ? "#E30425" : "#E7E7E7";
}, function (_ref9) {
  var label = _ref9.label;
  return label ? "0" : "1";
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.primary;
});

var Label = styled.div.withConfig({
  displayName: "Input__Label",
  componentId: "q0n91z-2"
})(["position:absolute;pointer-events:none;top:0;left:calc(1em - 1px);font-size:18px;line-height:24px;color:", ";transform:scale(1) translate(0,24px);transition:transform 0.2s ease-out,scale 0.2s ease-out,color 0.2s ease-out;transform-origin:bottom left;", " ", ":focus ~ &{", "}"], function (_ref11) {
  var theme = _ref11.theme,
      error = _ref11.error;
  return error ? "#E30425" : "#7E7E7E";
}, function (_ref12) {
  var inputHasValue = _ref12.inputHasValue;
  return inputHasValue && smallLabelStyling;
}, InputField, function (props) {
  return smallLabelStyling;
});

var IconSearch = styled(FiSearch).withConfig({
  displayName: "Input__IconSearch",
  componentId: "q0n91z-3"
})(["position:absolute;left:1em;top:1.5em;width:1.5em;height:1.5em;"]);

var Icon = styled.div.withConfig({
  displayName: "Input__Icon",
  componentId: "q0n91z-4"
})(["box-sizing:border-box;position:absolute;top:0;right:1em;height:100%;display:flex;align-items:center;justify-content:flex-end;& svg{width:1.5em;height:1.5em;}"]);

var ErrorMessage = styled.div.withConfig({
  displayName: "Input__ErrorMessage",
  componentId: "q0n91z-5"
})(["display:flex;align-items:center;margin-top:0.25em;color:#e30425;"]);

var StyledFiAlertCircle = styled(FiAlertCircle).withConfig({
  displayName: "Input__StyledFiAlertCircle",
  componentId: "q0n91z-6"
})(["font-size:1em;"]);

var ErrorText = styled.div.withConfig({
  displayName: "Input__ErrorText",
  componentId: "q0n91z-7"
})(["margin-left:0.5em;font-size:0.75em;"]);

var smallLabelStyling = css(["transform:scale(0.66) translate(0,0.66em);color:", ";"], function (_ref13) {
  var theme = _ref13.theme,
      error = _ref13.error;
  return error ? "#E30425" : theme.primary;
});

Input.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  search: PropTypes.bool,
  inputRef: PropTypes.func
} : {};

Input.defaultProps = {
  error: false
};

Input.Icon = Icon;
Input.InputField = InputField;

export default Input;